import { useState, useEffect } from 'react';
import { X, Cookie } from 'lucide-react';
import { Link } from 'react-router-dom';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already consented to cookies
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      // Small delay to show banner after page loads
      setTimeout(() => {
        setShowBanner(true);
      }, 1000);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    setShowBanner(false);
  };

  const handleReject = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    setShowBanner(false);
  };

  const handleClose = () => {
    // Just close without storing preference (user can accept/reject later)
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-4 right-4 left-4 sm:left-auto bg-dark-black border-2 border-toxic-orange rounded-lg p-4 max-w-sm shadow-2xl z-40 animate-slide-up">
      <div className="flex items-start gap-3 mb-3">
        <Cookie className="text-toxic-orange flex-shrink-0 mt-1" size={24} />
        <div className="flex-1">
          <h3 className="text-white font-semibold mb-2">Cookie Preferences</h3>
          <p className="text-gray-300 text-sm leading-relaxed mb-3">
            We use cookies to enhance your experience, analyze site usage, and assist in our marketing efforts. By clicking "Accept", you consent to our use of cookies.
          </p>
          <Link 
            to="/cookie-policy"
            data-discover="true"
            className="text-toxic-orange hover:text-orange-400 text-sm font-semibold"
          >
            Learn more
          </Link>
        </div>
        <button
          onClick={handleClose}
          className="text-gray-400 hover:text-white transition-colors flex-shrink-0"
          aria-label="Close cookie banner"
        >
          <X size={20} />
        </button>
      </div>

      <div className="flex gap-2 mt-4">
        <button
          onClick={handleReject}
          className="flex-1 border border-gray-600 text-gray-300 px-4 py-2 rounded-lg text-sm font-semibold hover:border-gray-500 hover:text-white transition-colors"
        >
          Reject
        </button>
        <button
          onClick={handleAccept}
          className="flex-1 bg-toxic-orange text-dark-black px-4 py-2 rounded-lg text-sm font-semibold hover:bg-orange-500 transition-colors"
        >
          Accept
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;

